<template>
  <div class="container_wrap">
    <div class="content_title">{{ cmsDetailData.title }}</div>
    <div class="content_date">
      发布日期：{{ cmsDetailData.create_time | timeFormat }}
    </div>
    <div class="content_container html-data" v-html="cmsDetailData.content"></div>
  </div>
</template>
<script>
export default {
  name: "CmsSinglePage",
  data() {
    return {
      cmsDetailData: "",
    };
  },
  mounted() {
    this.getPageDetailFun();
  },
  methods: {
    getPageDetailFun() {
      if (!this.$route.query.id) {
        this.$message({ type: "error", message: "id参数错误！" });
        return;
      }
      this.$api.get(
        "/api/cms/detail",
        { id: this.$route.query.id },
        (res) => {
          this.cmsDetailData = res.data.data;
        },
        (err) => {
          this.$message({ type: "error", message: err.msg });
        }
      );
    },
  },
  //   watch: {
  //     $route: {
  //       handler() {
  //         this.getCateDetailFun(this.$route.query.id);
  //       },
  //       deep: true,
  //     },
  //   },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: calc(100vh - 446px);
  overflow: hidden;
}
.content_title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 22px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.content_date {
  width: 100%;
  text-align: center;
  font-size: 16px;
  margin-top: 5px;
  color: #9b9b9b;
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// CmsSinglePage.vue?0277bade